module.exports = __webpack_public_path__ + "img/img2.ef23ace9.jpeg";